import SortBy from "../../common/components/FiltersPanel/SortBy";
import License from "../../common/components/FiltersPanel/License";
import Orientation from "../../common/components/FiltersPanel/Orientation";
import Resolution from "../../common/components/FiltersPanel/Resolution";
import Duration from "../../common/components/FiltersPanel/Duration";
import People from "../../common/components/FiltersPanel/People";
import Color from "../../common/components/FiltersPanel/Color";
import More from "../../common/components/FiltersPanel/More";
import MinimumSize from "../components/Filters/MinimumSize";
import Compositions from "../components/Filters/Compositions";
import FrameRates from "../components/Filters/FrameRates";
import Viewpoints from "../components/Filters/Viewpoints";
import ImageTechniques from "../components/Filters/ImageTechniques";
import VideoCompositions from "../components/Filters/VideoCompositions";
import ImagesMore from "../components/Filters/ImageMore";
import LicenseModels from "../components/Filters/LicenseModels";

export const FILTERS_MAP = [
	{
		name: "sortBy",
		component: SortBy
	},
	{
		name: "license",
		component: License
	},
	{
		name: "orientations",
		component: Orientation,
		params: {
			isMulti: true
		}
	},
	{
		name: "minimumSize",
		component: MinimumSize
	},
	{
		name: "licenseModels",
		component: LicenseModels
	},
	{
		name: "formatAvailable",
		component: Resolution
	},
	{
		name: "duration",
		component: Duration
	},
	{
		name: "numberOfPeople",
		component: People,
		params: {
			isMulti: true
		}
	},
	{
		name: "compositions",
		component: Compositions,
		params: {
			isMulti: true
		}
	},
	{
		name: "videoCompositions",
		component: VideoCompositions,
		params: {
			isMulti: true
		}
	},
	{
		name: "frameRates",
		component: FrameRates,
		params: {
			isMulti: true
		}
	},
	{
		name: "viewpoints",
		component: Viewpoints,
		params: {
			isMulti: true
		}
	},
	{
		name: "imageTechniques",
		component: ImageTechniques,
		params: {
			isMulti: true
		}
	},
	{
		name: "color",
		component: Color
	},
	{
		name: "more",
		component: More
	},
	{
		name: "imagesMore",
		component: ImagesMore
	},

];
